import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { FlowProvider } from '../contexts/FlowContext';
import { GoogleSsoProvider } from './contexts/GoogleSsoContext';
import { RequireAuth } from './components/RequireAuth';
import { SignInScreen } from './screens/SignInScreen';
import { SignUpScreen } from './screens/SignUpScreen';
import { PhoneScreen } from './screens/PhoneScreen';
import { UploadFlowScreen } from './screens/UploadFlowScreen';
import { BookOptionsScreen } from './screens/BookOptionsScreen';
import { TitleScreen } from './screens/TitleScreen';
import { InstructionsScreen } from './screens/InstructionsScreen';
import { ConfirmationScreen } from './screens/ConfirmationScreen';

const withAuth = (screen: React.ReactElement) => (
  <RequireAuth>{screen}</RequireAuth>
);

export const FlowApp: React.FC = () => (
  <GoogleSsoProvider>
    <FlowProvider>
      <Routes>
      <Route path="/" element={<Navigate to="/signin" replace />} />
      <Route path="/signin" element={<SignInScreen />} />
      <Route path="/signup" element={<SignUpScreen />} />
      <Route path="/phone" element={withAuth(<PhoneScreen />)} />
      <Route path="/upload" element={withAuth(<UploadFlowScreen />)} />
      <Route path="/book" element={withAuth(<BookOptionsScreen />)} />
      <Route path="/title" element={withAuth(<TitleScreen />)} />
      <Route path="/instructions" element={withAuth(<InstructionsScreen />)} />
      <Route path="/done" element={withAuth(<ConfirmationScreen />)} />
      <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </FlowProvider>
  </GoogleSsoProvider>
);
